export const getImageUri = (name: string): string => {
    return `https://www.salvators.com.co/wp-content/uploads/2020/10/${name}.png`;
};